"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getErrorMessage(error, translate) {
  if (error === null || error === undefined) return;
  return translate['es'].ERROR[error === null || error === void 0 ? void 0 : error.toLocaleUpperCase()] || translate['es'].ERROR.DEFAULT;
}
var _default = exports.default = getErrorMessage;